import React from 'react';

/* ── design tokens (same as all containers) ── */
const T = {
    card: '#FFFFFF',
    line: '#E5E2D8',
    ink:  '#232821',
    mut:  '#6E766C',
    acc:  '#2E9E7A',
    err:  '#D9614F',
    errBg:'#FDF2F0',
};

/**
 * SectionError
 * Props:
 *   message  {string}   — user-facing error text
 *   onRetry  {function} — optional; if omitted, no retry button is shown
 */
const SectionError = ({ message, onRetry }) => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: '28px 20px',
        textAlign: 'center',
    }}>
        {/* Warning icon */}
        <div style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: T.errBg,
            border: `1px solid ${T.err}30`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 18,
            flexShrink: 0,
        }}>
            ⚠
        </div>

        {/* Message */}
        <p style={{
            fontSize: 13,
            color: T.mut,
            lineHeight: 1.5,
            margin: 0,
            maxWidth: 320,
        }}>
            {message || 'Something went wrong. Please try again.'}
        </p>

        {/* Retry button (only if handler provided) */}
        {onRetry && (
            <button
                onClick={onRetry}
                style={{
                    marginTop: 4,
                    padding: '7px 18px',
                    borderRadius: 999,
                    border: `1px solid ${T.acc}`,
                    background: 'transparent',
                    color: T.acc,
                    fontSize: 12.5,
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    transition: 'background 0.15s, color 0.15s',
                }}
                onMouseEnter={e => {
                    e.currentTarget.style.background = T.acc;
                    e.currentTarget.style.color = '#fff';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = T.acc;
                }}
            >
                ↺ Retry
            </button>
        )}
    </div>
);

export default SectionError;
